import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function MoonIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M19.55 4.91449C20.0069 5.27287 19.5807 6 19 6C15.6863 6 13 8.68629 13 12C13 15.3137 15.6863 18 19 18C19.5807 18 20.0069 18.7271 19.55 19.0855C18.021 20.2849 16.094 21 14 21C9.02944 21 5 16.9706 5 12C5 7.02944 9.02944 3 14 3C16.094 3 18.021 3.71513 19.55 4.91449Z"
        fill="currentColor"
      />
    </svg>
  )
}
